import { render } from "./CreateExpensesFrom.vue?vue&type=template&id=1f1760d9"
import script from "./CreateExpensesFrom.vue?vue&type=script&lang=js"
export * from "./CreateExpensesFrom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__